import React from "react";
import SORT_DEFAULT from "constants/SORT_DEFAULT";
import SORT_ASCENDING from "constants/SORT_ASCENDING";
import SORT_DESCENDING from "constants/SORT_DESCENDING";

const sort_transition_disable_default = {
  [SORT_ASCENDING]: SORT_DESCENDING,
  [SORT_DESCENDING]: SORT_ASCENDING,
};

const sort_transition_enable_default = {
  [SORT_DEFAULT]: SORT_ASCENDING,
  [SORT_ASCENDING]: SORT_DESCENDING,
  [SORT_DESCENDING]: SORT_DEFAULT,
};

const sort_transition = {
  false: sort_transition_disable_default,
  true: sort_transition_enable_default,
};

export default function useSort(useDefault = true, defaultSort = SORT_DEFAULT) {
  const [order, setOrder] = React.useState(() => defaultSort);
  const onOrderChange = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setOrder(b => sort_transition[useDefault][b]);
  }, []);
  return {
    order,
    onOrderChange,
  };
}